import React, { useState, useRef, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import GradientIcon from '../components/GradientIcon';
import SpeakersWidget from '../components/SpeakersWidget';
import SpeakerSpotlight from '../components/SpeakerSpotlight';
import BookShowcase from '../components/BookShowcase';

const PRICING_TIERS = [
  {
    period: 1,
    startDate: '2025-11-19',
    endDate: '2025-11-30',
  },
  {
    period: 2,
    startDate: '2025-12-01',
    endDate: '2025-12-31',
  },
  {
    period: 3,
    startDate: '2026-01-01',
    endDate: '2026-01-31',
  },
  {
    period: 4,
    startDate: '2026-02-01',
    endDate: '2026-03-01',
  },
  {
    period: 5,
    startDate: '2026-03-02',
    endDate: '2026-05-31',
  },
  {
    period: 6,
    startDate: '2026-06-01',
    endDate: '2026-06-10',
  },
  {
    period: 7,
    startDate: '2026-06-11',
    endDate: '2026-06-20',
  },
];

function HomePage() {
  const [showPlayButton, setShowPlayButton] = useState(true);
  const videoRef = useRef(null);

  // Calculate and set timer target date
  useEffect(() => {
    const today = new Date();
    let currentPeriod = null;
    
    // Find current period
    for (const tier of PRICING_TIERS) {
      const start = new Date(tier.startDate);
      const end = new Date(tier.endDate);
      end.setHours(23, 59, 59, 999);
      
      if (today >= start && today <= end) {
        currentPeriod = tier;
        break;
      }
    }
    
    // If no current period, find next period
    if (!currentPeriod) {
      for (const tier of PRICING_TIERS) {
        const start = new Date(tier.startDate);
        if (today < start) {
          currentPeriod = tier;
          break;
        }
      }
    }
    
    // Set target date
    if (currentPeriod) {
      const endDate = new Date(currentPeriod.endDate);
      endDate.setHours(23, 59, 59, 999);
      window.nextPriceIncreaseDate = endDate;
    } else {
      // Fallback: last period end date
      const lastPeriod = PRICING_TIERS[PRICING_TIERS.length - 1];
      const endDate = new Date(lastPeriod.endDate);
      endDate.setHours(23, 59, 59, 999);
      window.nextPriceIncreaseDate = endDate;
    }
    
    // Make pricingTiers available globally for script.js
    window.pricingTiers = PRICING_TIERS;
    
    // Reinitialize countdown if function exists
    if (window.initCountdown) {
      window.initCountdown();
    }
  }, []);

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setShowPlayButton(false);
    }
  };

  const handleVideoPause = () => {
    setShowPlayButton(true);
  };

  const handleVideoPlay = () => {
    setShowPlayButton(false);
  };
  return (
    <>
      <Navbar />
      <SpeakersWidget />
      

    {/* Sticky Navigation */}
    {/* Navbar component */}

    {/* Hero Section */}
    <section className="hero" id="hero" style={{paddingBottom: '3rem'}}>
        {/* Video Background */}
        <video 
            className="hero-background-video"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            onLoadedMetadata={(e) => {
                e.target.play();
            }}
            onEnded={(e) => {
                e.target.currentTime = 0;
                e.target.play();
            }}
        >
            <source src="/assets/video-hero.webm" type="video/webm" />
        </video>
        
        <div className="container">
            <div className="hero-content">
                <div className="hero-badge" style={{marginBottom: '10px'}}>
                    <span className="pulse-dot"></span>
                    Eveniment Fizic • București 2026
                </div>
                
                <h1 className="hero-title" style={{marginBottom: '10px'}}>
                    Totul pentru <span className="gradient-text">sănătatea creierului</span>, într-un singur eveniment
                </h1>
                
                <p className="hero-subtitle">
                    Eveniment fizic cu <strong>5 speakeri internaționali</strong> și <strong>3 speakeri români</strong> de top
                </p>

                {/* VSL Video */}
                <div className="vsl-video-wrapper">
                    <video 
                        ref={videoRef}
                        className="vsl-video"
                        controls
                        controlsList="nodownload"
                        disablePictureInPicture
                        playsInline
                        preload="metadata"
                        poster="/assets/thumbnail-video.webp"
                        onPlay={handleVideoPlay}
                        onPause={handleVideoPause}
                    >
                        <source src="https://storage.googleapis.com/msgsndr/r7vVLgPNRqJaEPUCZdOt/media/6941ae64db710a0135502f66.mp4" type="video/mp4" />
                        Video-ul nu poate fi vizualizat în browser-ul tău.
                    </video>
                    
                    {showPlayButton && (
                        <div className="vsl-play-overlay" onClick={handlePlayClick}>
                            <button className="vsl-play-button" aria-label="Redare video">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                                    <circle cx="40" cy="40" r="40" fill="rgba(6, 182, 212, 0.9)" />
                                    <path d="M32 25L55 40L32 55V25Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    )}
                </div>

                {/* CTA Principal */}
                <div className="hero-cta">
                    <a href="/formular-inscriere" className="btn btn-large btn-primary btn-pulse">
                        <span>Rezervă locul acum</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </section>

    {/* Speakers Section - Gallery Style - Combined International & National */}
    <section className="speakers" id="speakeri">
        <div className="container">
            <div className="speakers-gallery-wrapper">
                {/* Main Gallery Grid - Custom Layout */}
                <div className="speakers-gallery-grid">
                    {/* Row 1 - Coloana 1: Matthew Walker (nivel normal) */}
                    <div className="speaker-gallery-card" id="matthew-walker">
                        <div className="speaker-gallery-image">
                            <img src="/assets/matthew-walker-speaker.webp" alt="Matthew Walker" loading="lazy" />
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">MATTHEW WALKER</h3>
                            <p className="speaker-gallery-role">Expert în Somnologie • Autor Bestseller</p>
                        </div>
                    </div>

                    {/* Row 1 - Coloana 2: David Sinclair (mai sus) */}
                    <div className="speaker-gallery-card speaker-gallery-elevated" id="david-sinclair">
                        <div className="speaker-gallery-image">
                            <img src="/david-sinclair-headshot-2024.webp" alt="David Sinclair" loading="lazy" />
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">DAVID SINCLAIR</h3>
                            <p className="speaker-gallery-role">Cercetător în genetică & expert global în longevity</p>
                        </div>
                    </div>

                    {/* Row 1 - Coloana 3: Dr. Daniel Amen (nivel cu Matthew) */}
                    <div className="speaker-gallery-card" id="dr-amen">
                        <div className="speaker-gallery-image">
                            <img src="/assets/amen-speaker.webp" alt="Dr. Daniel Amen" loading="lazy" />
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">DR. DANIEL AMEN</h3>
                            <p className="speaker-gallery-role">Medic în Sănătatea Creierului • Prezență Online</p>
                        </div>
                    </div>

                    {/* Row 2 */}
                    {/* Diana Palotas */}
                    <div className="speaker-gallery-card" id="diana-palotas">
                        <div className="speaker-gallery-image">
                            <img src="/Diana-Palotas-card.webp" alt="Diana Palotas" loading="lazy" />
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">DIANA PALOTAS</h3>
                            <p className="speaker-gallery-role">Specialist în neuroștiință aplicată</p>
                        </div>
                    </div>

                    {/* Niculina - Psiholog */}
                    <div className="speaker-gallery-card" id="niculina">
                        <div className="speaker-gallery-image">
                            <img src="/assets/niculina-psiholog.webp" alt="Niculina" loading="lazy" />
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">NICULINA</h3>
                            <p className="speaker-gallery-role">Psiholog • Peste 20 de ani experiență</p>
                        </div>
                    </div>

                    {/* Speaker Misterios 3 */}
                    <div className="speaker-gallery-card speaker-gallery-mysterious">
                        <div className="speaker-gallery-image">
                            <img src="/mysterious-speaker-new.webp" alt="Speaker misterios" loading="lazy" />
                            <div className="mysterious-badge-gallery">VA FI ANUNȚAT</div>
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">SPECIALIST NEUROFEEDBACK</h3>
                            <p className="speaker-gallery-role">Experiență cu sportivi de elită</p>
                        </div>
                    </div>

                    {/* Row 3 */}
                    {/* Speaker Național - Medic */}
                    <div className="speaker-gallery-card speaker-gallery-mysterious">
                        <div className="speaker-gallery-image">
                            <img src="/mysterious-speaker-new.webp" alt="Speaker național" loading="lazy" />
                            <div className="mysterious-badge-gallery">VA FI ANUNȚAT</div>
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">MEDIC</h3>
                            <p className="speaker-gallery-role">Protocoale integrate</p>
                        </div>
                    </div>

                    {/* Speaker Național - Specialist */}
                    <div className="speaker-gallery-card speaker-gallery-mysterious">
                        <div className="speaker-gallery-image">
                            <img src="/mysterious-speaker-new.webp" alt="Speaker național" loading="lazy" />
                            <div className="mysterious-badge-gallery">VA FI ANUNȚAT</div>
                        </div>
                        <div className="speaker-gallery-content">
                            <h3 className="speaker-gallery-name">SPECIALIST</h3>
                            <p className="speaker-gallery-role">Confirmat</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-cta">
                <a href="/formular-inscriere" className="btn btn-primary btn-large">Vreau să-i întâlnesc</a>
            </div>
        </div>
    </section>

    {/* David Sinclair Spotlight Section */}
    <SpeakerSpotlight
      name="David Sinclair"
      title="Expert mondial în longevitate • Harvard Medical School"
      badge="DAVID SINCLAIR — INVITAT SPECIAL"
      description="Cercetările lui au schimbat modul în care lumea înțelege îmbătrânirea, energia și sănătatea creierului. La Brain Event, explică simplu ce funcționează și cum aplici imediat."
      image="/david-sinclair-headshot-2024.webp"
    />

    {/* David Sinclair Book Showcase */}
    <BookShowcase
      badge="Bestseller mondial"
      mainTitle="Autorul cărții &quot;Lifespan&quot;"
      description="&quot;Lifespan&quot; este una dintre cele mai populare cărți despre longevitate și sănătate. La Brain Event, vei vedea principiile din carte explicate clar și aplicabil."
      bookImage="/assets/lifespan-book-david-sinclair.webp"
      primaryButtonText="Rezervă bilet"
      primaryButtonLink="/formular-inscriere"
      secondaryButtonText="Află mai multe"
      secondaryButtonLink="/david-sinclair"
      backgroundColor="#F5F1E8"
    />

    {/* Pentru Cine Este Section */}
    <section className="for-who" id="pentru-cine">
        <div className="container">
            <div className="section-header">
                <h2 className="section-title">Pentru cine este?</h2>
                <p className="section-subtitle">Trei categorii de participanți care vor beneficia maxim</p>
            </div>

            <div className="persona-grid-new">
                {/* Persona 1: Interesați de sănătatea creierului */}
                <div className="persona-card-new">
                    <div className="persona-card-image" style={{backgroundImage: 'url(/assets/interesati.webp)'}}>
                        <div className="persona-card-title">
                            <h3>Interesați de sănătatea creierului</h3>
                        </div>
                    </div>
                    <div className="persona-card-overlay">
                        <div className="persona-card-content">
                            <div className="persona-card-title-overlay">
                                <h3>Interesați de sănătatea creierului</h3>
                            </div>
                            <div className="persona-quote">
                                "Vreau să am mai multă energie, focus și un somn mai bun."
                            </div>
                            <div className="persona-section">
                                <h4>Probleme frecvente:</h4>
                                <ul className="persona-problems">
                                    <li>Oboseală cronică</li>
                                    <li>Uitare</li>
                                    <li>Anxietate ușoară</li>
                                    <li>Somn dezordonat</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Persona 2: Biohackeri */}
                <div className="persona-card-new">
                    <div className="persona-card-image" style={{backgroundImage: 'url(/assets/biohackeri.webp)'}}>
                        <div className="persona-card-title">
                            <h3>Biohackeri & Optimizatori de performanță</h3>
                        </div>
                    </div>
                    <div className="persona-card-overlay">
                        <div className="persona-card-content">
                            <div className="persona-card-title-overlay">
                                <h3>Biohackeri & Optimizatori de performanță</h3>
                            </div>
                            <div className="persona-quote">
                                "Vreau protocoale simple, eficiente și rezultate măsurabile."
                            </div>
                            <div className="persona-section">
                                <h4>Probleme frecvente:</h4>
                                <ul className="persona-problems">
                                    <li>Rezultate în platou</li>
                                    <li>Prea multe informații</li>
                                    <li>Rutine care nu produc efecte reale</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Persona 3: Profesioniști */}
                <div className="persona-card-new">
                    <div className="persona-card-image" style={{backgroundImage: 'url(/assets/profesionisti.webp)'}}>
                        <div className="persona-card-title">
                            <h3>Profesioniști</h3>
                        </div>
                    </div>
                    <div className="persona-card-overlay">
                        <div className="persona-card-content">
                            <div className="persona-card-title-overlay">
                                <h3>Profesioniști</h3>
                            </div>
                            <div className="persona-quote">
                                "Vreau tehnici noi cu care să-mi ajut clienții și pacienții imediat."
                            </div>
                            <div className="persona-section">
                                <h4>Probleme frecvente:</h4>
                                <ul className="persona-problems">
                                    <li>Persoane rezistente la intervenții</li>
                                    <li>Progrese lente</li>
                                    <li>Lipsă protocoale clare</li>
                                    <li>Stres profesional ridicat</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-cta">
                <a href="/formular-inscriere" className="btn btn-primary btn-large">Vreau să particip</a>
            </div>
        </div>
    </section>

    {/* Ce Obții Section */}
    <section className="benefits" id="beneficii">
        <div className="container">
            <div className="section-header">
                <h2 className="section-title">Ce obții la eveniment</h2>
                <p className="section-subtitle">Experiență completă pe 3 piloni fundamentali</p>
            </div>

            <div className="benefits-stories-grid">
                {/* Pilon 1: Înveți */}
                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/bazele-sanatatii.webp)'}}>
                    <div className="story-badge">Înveți</div>
                    <div className="story-content">
                        <h3 className="story-title">Bazele sănătății creierului</h3>
                        <p className="story-description">Somn, lumină, mișcare, alimentație, respirație – explicate clar și aplicabil.</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/Identifici-cauzele-reale.webp)'}}>
                    <div className="story-badge">Înveți</div>
                    <div className="story-content">
                        <h3 className="story-title">Înțelegerea mecanismelor</h3>
                        <p className="story-description">Înțelegi mecanismele din spatele anxietății și energiei instabile.</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/structurezi-ziua.webp)'}}>
                    <div className="story-badge">Înveți</div>
                    <div className="story-content">
                        <h3 className="story-title">Structurarea zilei pentru performanță</h3>
                        <p className="story-description">Model zilnic bazat pe ritmul circadian pentru eficiență mentală maximă.</p>
                    </div>
                </div>

                {/* Pilon 2: Aplici */}
                <div className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/protocol-de-somn.webp)'}}>
                    <div className="story-badge story-badge-featured">Aplici</div>
                    <div className="story-content">
                        <h3 className="story-title">Protocol de somn pas cu pas</h3>
                        <p className="story-description">Plan complet seară → noapte → dimineață, implementabil imediat.</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/ritualuri-rapide.webp)'}}>
                    <div className="story-badge">Aplici</div>
                    <div className="story-content">
                        <h3 className="story-title">Ritualuri rapide pentru energie</h3>
                        <p className="story-description">Tehnici de 5–10 minute pentru claritate, focus și reducerea stresului.</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/plan-personal.webp)'}}>
                    <div className="story-badge">Aplici</div>
                    <div className="story-content">
                        <h3 className="story-title">Plan personal 7/30/90 zile</h3>
                        <p className="story-description">Structură clară pe etape pentru rezultate predictibile.</p>
                    </div>
                </div>

                {/* Pilon 3: Primești */}
                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/brain-notes.webp)'}}>
                    <div className="story-badge">Primești</div>
                    <div className="story-content">
                        <h3 className="story-title">Brain Notes — workbook complet</h3>
                        <p className="story-description">Protocoale, checklists, exerciții, planuri.</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/3-instrumente.webp)'}}>
                    <div className="story-badge">Primești</div>
                    <div className="story-content">
                        <h3 className="story-title">3 instrumente de auto-monitorizare</h3>
                        <p className="story-description">Tracking ușor pentru focus, stres și somn.</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/brain-mapping-inclus-pentru-toti.webp)'}}>
                    <div className="story-badge">Primești</div>
                    <div className="story-content">
                        <h3 className="story-title">Brain Mapping inclus pentru toți</h3>
                        <p className="story-description">Toți participanții primesc acces la Brain Mapping inclus în bilet</p>
                    </div>
                </div>

                <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/q&a-session.webp)'}}>
                    <div className="story-badge">Primești</div>
                    <div className="story-content">
                        <h3 className="story-title">Q&A live cu speakerii</h3>
                        <p className="story-description">Întrebări directe și răspunsuri aplicate.</p>
                    </div>
                </div>
            </div>

            <div className="section-cta">
                <a href="/formular-inscriere" className="btn btn-primary btn-large">Vreau experiența completă</a>
            </div>
        </div>
    </section>

    {/* Ce Obții pe Termen Lung Section - Discover Layout */}
    <section className="long-term-benefits" id="termen-lung">
        <div className="container">
            <div className="section-header">
                <h2 className="section-title">Ce obții pe termen lung</h2>
                <p className="section-subtitle">Transformări durabile pentru sănătatea ta mentală</p>
            </div>

            <div className="discover-layout">
                {/* Coloana 1 - Left Benefits */}
                <div className="discover-benefit discover-benefit-tl">
                    <h4>Claritate mentală</h4>
                    <p>Capacitatea de a gândi clar, de a lua decizii rapide și de a-ți menține concentrarea pe termen lung.</p>
                </div>

                <div className="discover-benefit discover-benefit-tl2">
                    <h4>Somn optimizat</h4>
                    <p>Protocoale științifice pentru un somn profund și recuperator, esențial pentru sănătatea creierului.</p>
                </div>

                <div className="discover-benefit discover-benefit-tl3">
                    <h4>Energie constantă</h4>
                    <p>Menținerea unui nivel stabil de energie pe tot parcursul zilei, fără fluctuații sau prăbușiri.</p>
                </div>

                {/* Coloana 2 - Center: Image + Bottom Benefit */}
                <div className="discover-center">
                    <div className="discover-image">
                        <img className="discover-image-desktop" src="/assets/image-ce-obtii-pe-termen-lunk.webp" alt="Ce obții pe termen lung" loading="lazy" />
                        <img className="discover-image-mobile" src="/assets/mobile-ce-obtii-pe-termen-lung.webp" alt="Ce obții pe termen lung" loading="lazy" />
                    </div>
                </div>

                <div className="discover-benefit discover-benefit-bc">
                    <h4>Control real asupra stării mentale</h4>
                    <p>Abilitatea de a-ți gestiona emoțiile și starea mentală în orice situație.</p>
                </div>

                {/* Coloana 3 - Right Benefits */}
                <div className="discover-benefit discover-benefit-tr">
                    <h4>Reducerea stresului</h4>
                    <p>Tehnici dovedite pentru gestionarea eficientă a stresului și anxietății zilnice.</p>
                </div>

                <div className="discover-benefit discover-benefit-tr2">
                    <h4>Structură zilnică sănătoasă</h4>
                    <p>Crearea și menținerea unor obiceiuri care susțin sănătatea cognitivă pe termen lung.</p>
                </div>

                <div className="discover-benefit discover-benefit-tr3">
                    <h4>Memorie îmbunătățită</h4>
                    <p>Îmbunătățirea capacității de memorare și retenție a informațiilor importante.</p>
                </div>

            </div>

            <div className="section-cta">
                <a href="/formular-inscriere" className="btn btn-primary btn-large">Vreau transformarea</a>
            </div>
        </div>
    </section>

    {/* Testimonials Section */}
    <section className="testimonials" id="testimoniale">
        <div className="container">
            <div className="section-header">
                <h2 className="section-title">Ce spun participanții</h2>
                <p className="section-subtitle">Feedback autentic de la ediția anterioară</p>
            </div>

            {/* Stats First - Impact Numbers */}
            <div className="testimonial-stats-hero">
                <div className="stat-hero-item">
                    <div className="stat-hero-number">1000+</div>
                    <div className="stat-hero-label">Participanți</div>
                    <div className="stat-hero-sublabel">ediția trecută</div>
                </div>
                <div className="stat-hero-divider"></div>
                <div className="stat-hero-item stat-hero-featured">
                    <div className="stat-hero-number">10/10</div>
                    <div className="stat-hero-label">Rating mediu</div>
                    <div className="stat-hero-sublabel">satisfacție maximă</div>
                </div>
                <div className="stat-hero-divider"></div>
                <div className="stat-hero-item">
                    <div className="stat-hero-number">95%</div>
                    <div className="stat-hero-label">Recomandare</div>
                    <div className="stat-hero-sublabel">ar participa din nou</div>
                </div>
            </div>

            {/* Testimonials Grid */}
            <div className="testimonials-grid-modern">
                {/* Testimonial 1 - Featured Large */}
                <div className="testimonial-card-modern featured-large">
                    <div className="testimonial-quote-icon">"</div>
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Am plecat cu un plan concret pentru somn și am văzut rezultate în doar 5 zile. Claritate mentală pe care nu am mai simțit-o de ani. Protocoalele sunt simple dar puternice."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>AM</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Ana Maria</strong>
                            <span className="author-role-modern">Antreprenor, 34 ani</span>
                            <span className="author-result">✓ Focus +40% în 7 zile</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 2 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Ca psiholog, am găsit protocoale practice pe care le-am integrat imediat cu clienții mei. Schimbarea a fost vizibilă în primele 2 săptămâni."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>RP</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Radu Popa</strong>
                            <span className="author-role-modern">Psiholog clinician</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 3 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Informații dense dar accesibile. Am ieșit cu instrumente măsurabile și o comunitate de oameni pasionați de aceleași lucruri."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>MC</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Maria Cristea</strong>
                            <span className="author-role-modern">Biohacker & Coach</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 4 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Mi-am rezolvat problemele de somn după 10 ani de încercări. Acum dorm 7h/noapte și mă trezesc energizat. Schimbător de viață!"</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>DI</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Dan Ionescu</strong>
                            <span className="author-role-modern">Developer, 29 ani</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 5 - Video Style */}
                <div className="testimonial-card-modern video-style">
                    <div className="video-badge">🎥 Recenzie Video</div>
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Cel mai practic eveniment la care am participat. Zero fluff, doar acțiuni concrete. Workbook-ul e aur curat!"</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>SI</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Simona Ilie</strong>
                            <span className="author-role-modern">Manager HR</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 6 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Am venit sceptic, am plecat convins. Informațiile sunt bazate pe știință, nu pe hype. Super valoros pentru echipa mea."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>AL</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Alex Luca</strong>
                            <span className="author-role-modern">CEO Startup</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 7 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"M-a impresionat nivelul de profesionalism și calitatea informațiilor. Am aplicat tehnicile de respirație și deja simt diferența în gestionarea stresului."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>IC</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Ioana Constantin</strong>
                            <span className="author-role-modern">Avocat, 41 ani</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 8 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Exact ce aveam nevoie pentru a înțelege legătura dintre alimentație și performanță mentală. Recomandările sunt clare și ușor de implementat în viața de zi cu zi."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>MV</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Mihai Vasile</strong>
                            <span className="author-role-modern">Arhitect, 36 ani</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 9 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Eveniment excelent! Am învățat tehnici concrete pentru a-mi gestiona mai bine energia pe parcursul zilei. În doar 2 săptămâni am observat o îmbunătățire semnificativă."</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>CT</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Carmen Toma</strong>
                            <span className="author-role-modern">Designer, 32 ani</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 10 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Investiție care merită fiecare ban. Protocoalele de optimizare cognitivă sunt ușor de urmat și rezultatele sunt vizibile rapid. Concentrarea mi s-a dublat!"</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>VG</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Victor Gheorghe</strong>
                            <span className="author-role-modern">Consultant, 38 ani</span>
                        </div>
                    </div>
                </div>

                {/* Testimonial 11 */}
                <div className="testimonial-card-modern">
                    <div className="testimonial-rating">
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                        <span className="star-filled">★</span>
                    </div>
                    <p className="testimonial-text-modern">"Ca medic, sunt foarte exigent cu informațiile pe care le primesc. Aici totul este bazat pe cercetări serioase și aplicabil în practică. Recomand cu încredere!"</p>
                    <div className="testimonial-author-modern">
                        <div className="author-avatar-modern">
                            <span>LP</span>
                        </div>
                        <div className="author-details">
                            <strong className="author-name-modern">Dr. Laura Petre</strong>
                            <span className="author-role-modern">Medic de familie</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-cta">
                <a href="/formular-inscriere" className="btn btn-primary btn-large">Vreau și eu rezultate</a>
            </div>
        </div>
    </section>

    {/* Packages Section */}
    <section className="packages" id="pachete">
        <div className="container">
            <div className="section-header">
                <h2 className="section-title">Pachete și locuri</h2>
                <p className="section-subtitle">Alege varianta potrivită pentru tine</p>
            </div>

            <div className="packages-pricing-grid">
                {/* Standard Package - Left */}
                <div className="package-pricing-card package-pricing-small">
                    <div className="package-pricing-header">
                        <h3 className="package-pricing-title">Standard</h3>
                        <p className="package-pricing-description">Pachet de bază pentru participarea la eveniment</p>
                    </div>
                    <div className="package-pricing-content">
                        <p className="package-pricing-label">Ce este inclus:</p>
                        <ul className="package-pricing-benefits">
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Acces complet la eveniment</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Acces la toate prezentările speakerilor</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Prânz inclus</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Brain Mapping (în valoare de 500€)</span>
                            </li>
                        </ul>
                    </div>
                    <div className="package-pricing-footer">
                        <a href="/formular-inscriere" className="btn btn-outline btn-block">Solicită ofertă</a>
                    </div>
                </div>

                {/* VIP Package - Center (Featured) */}
                <div className="package-pricing-card package-pricing-featured" style={{backgroundImage: 'url(/assets/background-cards.webp)'}}>
                    <div className="package-pricing-badge">Cel mai popular</div>
                    <div className="package-pricing-header">
                        <h3 className="package-pricing-title">VIP</h3>
                        <p className="package-pricing-description">Experiență premium cu acces exclusiv</p>
                    </div>
                    <div className="package-pricing-content">
                        <p className="package-pricing-label">Ce este inclus:</p>
                        <ul className="package-pricing-benefits">
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Include TOT din Standard, plus:</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Locuri în zona premium (în față)</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Acces în comunitatea VIP</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Brain Notes – workbook fizic</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Goodie Bag (în valoare de 100€)</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Brain Mapping cu Diana (în valoare de 1000€)</span>
                            </li>
                        </ul>
                    </div>
                    <div className="package-pricing-footer">
                        <a href="/formular-inscriere" className="btn btn-vip-white btn-block">Vreau pachetul VIP</a>
                    </div>
                </div>

                {/* Ultra VIP Package - Right */}
                <div className="package-pricing-card package-pricing-small">
                    <div className="package-pricing-header">
                        <h3 className="package-pricing-title">Ultra VIP</h3>
                        <p className="package-pricing-description">Acces exclusiv cu experiență completă</p>
                    </div>
                    <div className="package-pricing-content">
                        <p className="package-pricing-label">Ce este inclus:</p>
                        <ul className="package-pricing-benefits">
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Include TOT din VIP, plus:</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Locuri în primele 4 rânduri</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Masă/Bufet separat pentru Ultra VIP</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Acces prioritar în sala</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Cină privată cu speakerii internaționali</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Networking dedicat cu speakerii</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Prioritate la întrebările adresate în Q&A</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Aparatul de stimulare la nervul vag (în valoare de 1000€)</span>
                            </li>
                            <li>
                                <div className="package-checkmark">
                                    <GradientIcon type="checkmark" />
                                </div>
                                <span>Goodie Bag (în valoare de 200€)</span>
                            </li>
                        </ul>
                    </div>
                    <div className="package-pricing-footer">
                        <a href="/formular-inscriere" className="btn btn-outline btn-block">Solicită ofertă Ultra VIP</a>
                    </div>
                </div>
            </div>

            <div className="section-cta">
                <a href="/formular-inscriere" className="btn btn-primary btn-large">Rezervă-ți locul înainte să crească prețurile</a>
            </div>
        </div>
    </section>

    {/* FAQ Section */}
    <section className="faq" id="faq">
        <div className="container">
            <div className="faq-header-new">
                <p className="faq-eyebrow">Întrebări Frecvente</p>
                <h2 className="faq-main-title">Tot ce trebuie să știi: Răspunsuri clare la întrebările tale</h2>
                <div className="faq-cta-buttons">
                    <a href="/formular-inscriere" className="btn btn-primary btn-large">Înscrie-te acum</a>
                    <a href="#pachete" className="btn btn-outline btn-large">Vezi pachete</a>
                </div>
            </div>

            <div className="faq-container">
                <div className="faq-item active">
                    <button className="faq-question">
                        <span>Unde și când are loc evenimentul?</span>
                        <svg className="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <div className="faq-answer">
                        <p>20 iunie 2026 • București • Sala Palatului</p>
                    </div>
                </div>

                <div className="faq-item">
                    <button className="faq-question">
                        <span>Cine poate participa?</span>
                        <svg className="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <div className="faq-answer">
                        <p>Oricine interesat de sănătatea creierului.<br />
                        Nu este nevoie de experiență în domeniu.</p>
                    </div>
                </div>

                <div className="faq-item">
                    <button className="faq-question">
                        <span>Brain Mapping-ul este inclus?</span>
                        <svg className="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <div className="faq-answer">
                        <p>Da, după achiziționarea biletului vei primi un mail pentru programarea brain mappingului.</p>
                    </div>
                </div>

                <div className="faq-item">
                    <button className="faq-question">
                        <span>Există înregistrare?</span>
                        <svg className="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <div className="faq-answer">
                        <p>Nu. Eveniment exclusiv LIVE în locație.</p>
                    </div>
                </div>

                <div className="faq-item">
                    <button className="faq-question">
                        <span>Este masa inclusă?</span>
                        <svg className="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <div className="faq-answer">
                        <p>Da.<br />
                        Toate pachetele includ prânz + coffee breaks.<br />
                        VIP & Ultra VIP → zonă separată.<br />
                        Ultra VIP → cină cu speakerii.</p>
                    </div>
                </div>
            </div>

            <div className="section-cta">
                <p className="cta-text">Nu ai găsit răspunsul?</p>
                <a href="/formular-inscriere" className="btn btn-secondary btn-large">Contactează-ne</a>
            </div>
        </div>
    </section>

    {/* Sticky Bottom Banner */}
    <div className="sticky-bottom-banner" id="stickyBanner">
        <button 
            className="banner-close" 
            onClick={(e) => {
                const banner = e.target.closest('.sticky-bottom-banner');
                if (banner) banner.style.display = 'none';
            }}
            aria-label="Închide banner"
        >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </button>
        <div className="banner-container">
            <div className="banner-content">
                <div className="banner-text">
                    <h3>Pana la urmatoarea scumpire</h3>
                    <p>Locuri limitate • Early Access</p>
                </div>
                <div className="banner-timer" id="urgencyTimer">
                    <div className="timer-block">
                        <span className="timer-number" id="days">00</span>
                        <span className="timer-label">Zile</span>
                    </div>
                    <div className="timer-divider">:</div>
                    <div className="timer-block">
                        <span className="timer-number" id="hours">00</span>
                        <span className="timer-label">Ore</span>
                    </div>
                    <div className="timer-divider">:</div>
                    <div className="timer-block">
                        <span className="timer-number" id="minutes">00</span>
                        <span className="timer-label">Min</span>
                    </div>
                    <div className="timer-divider">:</div>
                    <div className="timer-block">
                        <span className="timer-number" id="seconds">00</span>
                        <span className="timer-label">Sec</span>
                    </div>
                </div>
                <a href="/formular-inscriere" className="btn btn-large btn-white-banner">Rezervă acum locul</a>
            </div>
        </div>
    </div>

    {/* Footer */}
    {/* Footer component */}

    
    
    {/* Disabled - Too many WebGL contexts */}
    

      <Footer />
    </>
  );
}

export default HomePage;
